import Highcharts from 'highcharts/highstock'

// the weather icon in the conditions tooltip is an <img> with a base64 SVG data URI
Highcharts.AST.allowedReferences.push('data:image/svg+xml;charset=UTF-8;base64,')

// the "device data unavailable" icon in line chart tooltips is an inline <svg xmlns viewBox> with a rounded <rect rx>
Highcharts.AST.allowedAttributes.push('viewBox', 'rx', 'xmlns')
